module.exports = __webpack_public_path__ + "img/line.da91f492.jpg";